import { NoteTarget } from 'generated/graphql';

export function getNoteTargetId(targetType: NoteTarget, targetId: string, campaignId?: string): string {
  if (targetType === 'Entity') {
    return `${targetType}:c${campaignId}:${targetId}`;
  }

  const id = `${targetType}:${targetId}`;

  return id;
}
